unit uSubForm1;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls,
  WEBLib.ExtCtrls, WEBLib.CDS, DB, WEBLib.DB,
  WEBLib.Buttons, WEBLib.Imaging.pngimage;

type
  TSubForm1 = class(TForm)
    txtSelection: TLabel;
    WebLabel7: TLabel;
    WebLabel1: TLabel;
    WebGroupBox4: TGroupBox;
    WebLabel66: TLabel;
    WebLabel68: TLabel;
    WebLabel71: TLabel;
    WebLabel75: TLabel;
    WebLabel77: TLabel;
    WebLabel79: TLabel;
    WebLabel80: TLabel;
    WebLabel85: TLabel;
    WebLabel87: TLabel;
    WebLabel89: TLabel;
    WebLabel91: TLabel;
    WebEdit36: TEdit;
    WebEdit37: TEdit;
    WebEdit38: TEdit;
    WebEdit39: TEdit;
    WebEdit40: TEdit;
    WebEdit41: TEdit;
    WebEdit42: TEdit;
    WebEdit43: TEdit;
    WebEdit44: TEdit;
    WebEdit45: TEdit;
    WebEdit46: TEdit;
    WebEdit1: TEdit;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebEdit2: TEdit;
    WebLabel4: TLabel;
    WebEdit3: TEdit;
    WebLabel5: TLabel;
    WebEdit4: TEdit;
    WebLabel6: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    procedure WebBitBtn1Click(Sender: TObject);
    procedure WebBitBtn9Click(Sender: TObject);
    procedure WebBitBtn10Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebBitBtn2Click(Sender: TObject);
    procedure WebDBGrid1Click(Sender: TObject);
  protected
    procedure LoadDFMValues; override;

  end;

var
  SubForm1: TSubForm1;

implementation


uses  Factor;

procedure TSubForm1.WebBitBtn10Click(Sender: TObject);
var   AF : String;
begin
end;

procedure TSubForm1.WebBitBtn1Click(Sender: TObject);
var    edvalid, edinvalid: string;
begin
end;

procedure TSubForm1.WebBitBtn2Click(Sender: TObject);
var  NAS, MIA  : String;
begin
end;

procedure TSubForm1.WebBitBtn9Click(Sender: TObject);
var   IL     : Integer;
begin
end;

procedure TSubForm1.WebDBGrid1Click(Sender: TObject);
var   DIC               : String;
begin
end;

procedure TSubForm1.WebFormCreate(Sender: TObject);
var    edvalid, edinvalid: string;

begin
end;


procedure TSubForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  txtSelection := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebLabel71 := TLabel.Create(Self);
  WebLabel75 := TLabel.Create(Self);
  WebLabel77 := TLabel.Create(Self);
  WebLabel79 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel85 := TLabel.Create(Self);
  WebLabel87 := TLabel.Create(Self);
  WebLabel89 := TLabel.Create(Self);
  WebLabel91 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebEdit36 := TEdit.Create(Self);
  WebEdit37 := TEdit.Create(Self);
  WebEdit38 := TEdit.Create(Self);
  WebEdit39 := TEdit.Create(Self);
  WebEdit40 := TEdit.Create(Self);
  WebEdit41 := TEdit.Create(Self);
  WebEdit42 := TEdit.Create(Self);
  WebEdit43 := TEdit.Create(Self);
  WebEdit44 := TEdit.Create(Self);
  WebEdit45 := TEdit.Create(Self);
  WebEdit46 := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);

  txtSelection.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel75.BeforeLoadDFMValues;
  WebLabel77.BeforeLoadDFMValues;
  WebLabel79.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebEdit36.BeforeLoadDFMValues;
  WebEdit37.BeforeLoadDFMValues;
  WebEdit38.BeforeLoadDFMValues;
  WebEdit39.BeforeLoadDFMValues;
  WebEdit40.BeforeLoadDFMValues;
  WebEdit41.BeforeLoadDFMValues;
  WebEdit42.BeforeLoadDFMValues;
  WebEdit43.BeforeLoadDFMValues;
  WebEdit44.BeforeLoadDFMValues;
  WebEdit45.BeforeLoadDFMValues;
  WebEdit46.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  try
    Name := 'SubForm1';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 430;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    txtSelection.SetParentComponent(Self);
    txtSelection.Name := 'txtSelection';
    txtSelection.Left := 16;
    txtSelection.Top := 221;
    txtSelection.Width := 3;
    txtSelection.Height := 13;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 11;
    WebLabel7.Top := 402;
    WebLabel7.Width := 204;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel7.Color := clYellow;
    WebLabel7.Transparent := False;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 6;
    WebLabel1.Width := 124;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Kalkulacja odsetek ';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clMenuHighlight;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebGroupBox4.SetParentComponent(Self);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 8;
    WebGroupBox4.Top := 28;
    WebGroupBox4.Width := 620;
    WebGroupBox4.Height := 365;
    WebGroupBox4.Caption := 'Kalkulacja odsetek ';
    WebGroupBox4.ChildOrder := 27;
    WebLabel66.SetParentComponent(WebGroupBox4);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 18;
    WebLabel66.Top := 21;
    WebLabel66.Width := 109;
    WebLabel66.Height := 13;
    WebLabel66.Caption := 'Odsetki kapita'#322'owe';
    WebLabel66.Font.Charset := DEFAULT_CHARSET;
    WebLabel66.Font.Color := clWindowText;
    WebLabel66.Font.Height := -11;
    WebLabel66.Font.Name := 'Tahoma';
    WebLabel66.Font.Style := [fsBold];
    WebLabel66.ParentFont := False;
    WebLabel68.SetParentComponent(WebGroupBox4);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 18;
    WebLabel68.Top := 44;
    WebLabel68.Width := 112;
    WebLabel68.Height := 13;
    WebLabel68.Caption := 'Pewne oprocentowanie';
    WebLabel71.SetParentComponent(WebGroupBox4);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 18;
    WebLabel71.Top := 67;
    WebLabel71.Width := 140;
    WebLabel71.Height := 13;
    WebLabel71.Caption := '+ premia za ryzyko /wa'#380'ona/';
    WebLabel75.SetParentComponent(WebGroupBox4);
    WebLabel75.Name := 'WebLabel75';
    WebLabel75.Left := 18;
    WebLabel75.Top := 90;
    WebLabel75.Width := 199;
    WebLabel75.Height := 13;
    WebLabel75.Caption := 'Oprocentowanie kapita'#322'u w'#322'asnego';
    WebLabel75.Font.Charset := DEFAULT_CHARSET;
    WebLabel75.Font.Color := clWindowText;
    WebLabel75.Font.Height := -11;
    WebLabel75.Font.Name := 'Tahoma';
    WebLabel75.Font.Style := [fsBold];
    WebLabel75.ParentFont := False;
    WebLabel77.SetParentComponent(WebGroupBox4);
    WebLabel77.Name := 'WebLabel77';
    WebLabel77.Left := 18;
    WebLabel77.Top := 113;
    WebLabel77.Width := 175;
    WebLabel77.Height := 13;
    WebLabel77.Caption := 'Oprocentowanie akcji na rynku';
    WebLabel77.Font.Charset := DEFAULT_CHARSET;
    WebLabel77.Font.Color := clWindowText;
    WebLabel77.Font.Height := -11;
    WebLabel77.Font.Name := 'Tahoma';
    WebLabel77.Font.Style := [fsBold];
    WebLabel77.ParentFont := False;
    WebLabel79.SetParentComponent(WebGroupBox4);
    WebLabel79.Name := 'WebLabel79';
    WebLabel79.Left := 18;
    WebLabel79.Top := 136;
    WebLabel79.Width := 119;
    WebLabel79.Height := 13;
    WebLabel79.Caption := '/ pewne oprocentowanie';
    WebLabel80.SetParentComponent(WebGroupBox4);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 18;
    WebLabel80.Top := 159;
    WebLabel80.Width := 98;
    WebLabel80.Height := 13;
    WebLabel80.Caption := 'Premia za ryzyko';
    WebLabel80.Font.Charset := DEFAULT_CHARSET;
    WebLabel80.Font.Color := clWindowText;
    WebLabel80.Font.Height := -11;
    WebLabel80.Font.Name := 'Tahoma';
    WebLabel80.Font.Style := [fsBold];
    WebLabel80.ParentFont := False;
    WebLabel85.SetParentComponent(WebGroupBox4);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 18;
    WebLabel85.Top := 182;
    WebLabel85.Width := 129;
    WebLabel85.Height := 13;
    WebLabel85.Caption := 'Premia za ryzyko /wa'#380'ona/';
    WebLabel87.SetParentComponent(WebGroupBox4);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 17;
    WebLabel87.Top := 205;
    WebLabel87.Width := 116;
    WebLabel87.Height := 13;
    WebLabel87.Caption := 'Okre'#347'lenie ryzyka premii';
    WebLabel89.SetParentComponent(WebGroupBox4);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 17;
    WebLabel89.Top := 228;
    WebLabel89.Width := 118;
    WebLabel89.Height := 13;
    WebLabel89.Caption := 'Udzia'#322' premii kapita'#322'owej';
    WebLabel91.SetParentComponent(WebGroupBox4);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 17;
    WebLabel91.Top := 250;
    WebLabel91.Width := 119;
    WebLabel91.Height := 13;
    WebLabel91.Caption := 'Udzia'#322' kapita'#322'u w'#322'asnego';
    WebLabel2.SetParentComponent(WebGroupBox4);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 17;
    WebLabel2.Top := 273;
    WebLabel2.Width := 69;
    WebLabel2.Height := 13;
    WebLabel2.Caption := #321#261'czny kapita'#322;
    WebLabel3.SetParentComponent(WebGroupBox4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 17;
    WebLabel3.Top := 296;
    WebLabel3.Width := 71;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Obcy kapita'#322;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.ParentFont := False;
    WebLabel4.SetParentComponent(WebGroupBox4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 18;
    WebLabel4.Top := 319;
    WebLabel4.Width := 85;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'W'#322'asny kapita'#322;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.ParentFont := False;
    WebLabel5.SetParentComponent(WebGroupBox4);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 17;
    WebLabel5.Top := 342;
    WebLabel5.Width := 99;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Obliczone odsetki';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -11;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.ParentFont := False;
    WebLabel6.SetParentComponent(WebGroupBox4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 311;
    WebLabel6.Top := 21;
    WebLabel6.Width := 11;
    WebLabel6.Height := 13;
    WebLabel6.Caption := '%';
    WebLabel8.SetParentComponent(WebGroupBox4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 311;
    WebLabel8.Top := 44;
    WebLabel8.Width := 11;
    WebLabel8.Height := 13;
    WebLabel8.Caption := '%';
    WebLabel9.SetParentComponent(WebGroupBox4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 311;
    WebLabel9.Top := 67;
    WebLabel9.Width := 11;
    WebLabel9.Height := 13;
    WebLabel9.Caption := '%';
    WebLabel10.SetParentComponent(WebGroupBox4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 311;
    WebLabel10.Top := 90;
    WebLabel10.Width := 11;
    WebLabel10.Height := 13;
    WebLabel10.Caption := '%';
    WebLabel11.SetParentComponent(WebGroupBox4);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 311;
    WebLabel11.Top := 113;
    WebLabel11.Width := 11;
    WebLabel11.Height := 13;
    WebLabel11.Caption := '%';
    WebLabel12.SetParentComponent(WebGroupBox4);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 311;
    WebLabel12.Top := 136;
    WebLabel12.Width := 11;
    WebLabel12.Height := 13;
    WebLabel12.Caption := '%';
    WebLabel13.SetParentComponent(WebGroupBox4);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 311;
    WebLabel13.Top := 159;
    WebLabel13.Width := 11;
    WebLabel13.Height := 13;
    WebLabel13.Caption := '%';
    WebLabel14.SetParentComponent(WebGroupBox4);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 311;
    WebLabel14.Top := 182;
    WebLabel14.Width := 11;
    WebLabel14.Height := 13;
    WebLabel14.Caption := '%';
    WebLabel15.SetParentComponent(WebGroupBox4);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 311;
    WebLabel15.Top := 205;
    WebLabel15.Width := 11;
    WebLabel15.Height := 13;
    WebLabel15.Caption := '%';
    WebLabel16.SetParentComponent(WebGroupBox4);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 311;
    WebLabel16.Top := 228;
    WebLabel16.Width := 11;
    WebLabel16.Height := 13;
    WebLabel16.Caption := '%';
    WebLabel17.SetParentComponent(WebGroupBox4);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 311;
    WebLabel17.Top := 250;
    WebLabel17.Width := 11;
    WebLabel17.Height := 13;
    WebLabel17.Caption := '%';
    WebLabel18.SetParentComponent(WebGroupBox4);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 311;
    WebLabel18.Top := 273;
    WebLabel18.Width := 11;
    WebLabel18.Height := 13;
    WebLabel18.Caption := '%';
    WebLabel19.SetParentComponent(WebGroupBox4);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 311;
    WebLabel19.Top := 296;
    WebLabel19.Width := 11;
    WebLabel19.Height := 13;
    WebLabel19.Caption := '%';
    WebLabel20.SetParentComponent(WebGroupBox4);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 311;
    WebLabel20.Top := 319;
    WebLabel20.Width := 11;
    WebLabel20.Height := 13;
    WebLabel20.Caption := '%';
    WebLabel21.SetParentComponent(WebGroupBox4);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 311;
    WebLabel21.Top := 342;
    WebLabel21.Width := 11;
    WebLabel21.Height := 13;
    WebLabel21.Caption := '%';
    WebEdit36.SetParentComponent(WebGroupBox4);
    WebEdit36.Name := 'WebEdit36';
    WebEdit36.Left := 263;
    WebEdit36.Top := 41;
    WebEdit36.Width := 45;
    WebEdit36.Height := 19;
    WebEdit36.ChildOrder := 1;
    WebEdit36.Color := 12903679;
    WebEdit36.Enabled := False;
    WebEdit36.Text := '8,5';
    WebEdit37.SetParentComponent(WebGroupBox4);
    WebEdit37.Name := 'WebEdit37';
    WebEdit37.Left := 263;
    WebEdit37.Top := 64;
    WebEdit37.Width := 45;
    WebEdit37.Height := 19;
    WebEdit37.ChildOrder := 2;
    WebEdit37.Color := 12903679;
    WebEdit37.Enabled := False;
    WebEdit37.Text := '4,0';
    WebEdit38.SetParentComponent(WebGroupBox4);
    WebEdit38.Name := 'WebEdit38';
    WebEdit38.Left := 263;
    WebEdit38.Top := 87;
    WebEdit38.Width := 45;
    WebEdit38.Height := 19;
    WebEdit38.ChildOrder := 3;
    WebEdit38.Color := 12903679;
    WebEdit38.Enabled := False;
    WebEdit38.Text := '12,5';
    WebEdit39.SetParentComponent(WebGroupBox4);
    WebEdit39.Name := 'WebEdit39';
    WebEdit39.Left := 263;
    WebEdit39.Top := 110;
    WebEdit39.Width := 45;
    WebEdit39.Height := 19;
    WebEdit39.ChildOrder := 4;
    WebEdit39.Color := clInfoBk;
    WebEdit39.Text := '6,5';
    WebEdit40.SetParentComponent(WebGroupBox4);
    WebEdit40.Name := 'WebEdit40';
    WebEdit40.Left := 263;
    WebEdit40.Top := 133;
    WebEdit40.Width := 45;
    WebEdit40.Height := 19;
    WebEdit40.ChildOrder := 5;
    WebEdit40.Color := clInfoBk;
    WebEdit40.Text := '2,5';
    WebEdit41.SetParentComponent(WebGroupBox4);
    WebEdit41.Name := 'WebEdit41';
    WebEdit41.Left := 263;
    WebEdit41.Top := 156;
    WebEdit41.Width := 45;
    WebEdit41.Height := 19;
    WebEdit41.ChildOrder := 6;
    WebEdit41.Color := 12903679;
    WebEdit41.Text := '4';
    WebEdit42.SetParentComponent(WebGroupBox4);
    WebEdit42.Name := 'WebEdit42';
    WebEdit42.Left := 263;
    WebEdit42.Top := 179;
    WebEdit42.Width := 45;
    WebEdit42.Height := 19;
    WebEdit42.ChildOrder := 7;
    WebEdit42.Color := 12903679;
    WebEdit42.Enabled := False;
    WebEdit42.Text := '4';
    WebEdit43.SetParentComponent(WebGroupBox4);
    WebEdit43.Name := 'WebEdit43';
    WebEdit43.Left := 263;
    WebEdit43.Top := 18;
    WebEdit43.Width := 45;
    WebEdit43.Height := 19;
    WebEdit43.ChildOrder := 8;
    WebEdit43.Color := clInfoBk;
    WebEdit43.Text := '8,5';
    WebEdit44.SetParentComponent(WebGroupBox4);
    WebEdit44.Name := 'WebEdit44';
    WebEdit44.Left := 262;
    WebEdit44.Top := 202;
    WebEdit44.Width := 45;
    WebEdit44.Height := 19;
    WebEdit44.ChildOrder := 7;
    WebEdit44.Color := clInfoBk;
    WebEdit44.Text := '1';
    WebEdit45.SetParentComponent(WebGroupBox4);
    WebEdit45.Name := 'WebEdit45';
    WebEdit45.Left := 262;
    WebEdit45.Top := 225;
    WebEdit45.Width := 45;
    WebEdit45.Height := 19;
    WebEdit45.ChildOrder := 7;
    WebEdit45.Color := clInfoBk;
    WebEdit45.Text := '70';
    WebEdit46.SetParentComponent(WebGroupBox4);
    WebEdit46.Name := 'WebEdit46';
    WebEdit46.Left := 262;
    WebEdit46.Top := 247;
    WebEdit46.Width := 45;
    WebEdit46.Height := 19;
    WebEdit46.ChildOrder := 7;
    WebEdit46.Color := clInfoBk;
    WebEdit46.Text := '30';
    WebEdit1.SetParentComponent(WebGroupBox4);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 262;
    WebEdit1.Top := 270;
    WebEdit1.Width := 45;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 7;
    WebEdit1.Color := 12903679;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '100';
    WebEdit2.SetParentComponent(WebGroupBox4);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 262;
    WebEdit2.Top := 293;
    WebEdit2.Width := 45;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 7;
    WebEdit2.Color := 12903679;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '5,95';
    WebEdit3.SetParentComponent(WebGroupBox4);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 263;
    WebEdit3.Top := 316;
    WebEdit3.Width := 45;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 7;
    WebEdit3.Color := 12903679;
    WebEdit3.Enabled := False;
    WebEdit3.Text := '3,75';
    WebEdit4.SetParentComponent(WebGroupBox4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 262;
    WebEdit4.Top := 339;
    WebEdit4.Width := 45;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 7;
    WebEdit4.Color := 12903679;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '9,7';
  finally
    txtSelection.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel75.AfterLoadDFMValues;
    WebLabel77.AfterLoadDFMValues;
    WebLabel79.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebEdit36.AfterLoadDFMValues;
    WebEdit37.AfterLoadDFMValues;
    WebEdit38.AfterLoadDFMValues;
    WebEdit39.AfterLoadDFMValues;
    WebEdit40.AfterLoadDFMValues;
    WebEdit41.AfterLoadDFMValues;
    WebEdit42.AfterLoadDFMValues;
    WebEdit43.AfterLoadDFMValues;
    WebEdit44.AfterLoadDFMValues;
    WebEdit45.AfterLoadDFMValues;
    WebEdit46.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
  end;
end;

end.
